export default {
explore_by: "utforska efter",
explore_by_concepts: "idéer",
explore_by_families: "doftfamiljer",
language: "språk",
legal: "juridiskt",
find_any_fragrance: "hitta vilken doft som helst i världen.",
title_by_concepts: "utforska efter idéer",
desc_by_concepts: "hitta din doft genom att tänka på din favoritfärg eller plats",
title_by_families: "utforska efter familjer",
desc_by_families: "hitta din doft genom att tänka på ...",
expert_reviewed: "granskad av experter",
ingredients: "ingredienser",
description: "beskrivning",
perfumist: "parfymör",
concepts: "koncept",
olfactive_family: "doftfamilj",
main_family: "familj",
sub_family: "underfamilj",
me_family: "Världens dofter",
filter_by_family: "familjer",
filter_by_brand: "varumärken",
filter_by_gender: "kön",
for_him: "för honom",
for_her: "för henne",
unisex: "unisex",
all: "alla",
all_female: "alla",
concepts_list: "konceptlista",
no_results_for_this_combination: "inga parfymer för denna kombination.",
select_at_least_one_concept: "välj minst ett koncept",
view_perfumes: "visa parfymer",
back: "gå tillbaka",
close: "stäng",
filters: "filter",
selected_concepts: "valda koncept:",
selected_families: "valda familjer:",
find_concept: "sök koncept...",
smell_of: "doft av",
touch_of: "med en ton av",
loading_perfumes: "laddar parfymer",
loading_concepts: "laddar koncept",
apply: "applicera",
search: "sök",
clear_all: "rensa allt",
iconic_fragrances: "ikoniska dofter i denna familj",
is_there_anybody_here: "är du fortfarande här?",
continue_previous_session: "ja! fortsätt",
reset_session: "starta om upplevelsen",
ingredient_type: "typ",
ingredient_parts: "delar som används",
ingredient_extraction: "extraktionsmetod",
ingredient_first: "ikonisk parfym",
history: "historia",
effect: "produktion och effekt",
origin: "ursprung",
iconic_fragrance: "ikonisk doft",
production: "produktion",
loyalty_become_a_member: "Gå med i klubben",
loyalty_avolta_link: "https://qr.clubavolta.com/register?source=ctOffline-scDuty_Free-sgAirport&campaign=Fragrance_Finder_Tools"
}